<template>
<div class="chapter">
<div class="inner_page">
<div class="acknowPage">
<div class="title-acknowPage"><a href="#/e9781429908573_toc01#toctitle1" id="title1"><span><strong class="b">Acknowledgments</strong></span></a></div>
<div class="p"><span>Many people have helped me with the writing of this novel, in many ways. Russell Celyn Jones, Amanda Craig, Joanna Briscoe, Charlotte Mendelsohn, Bill Saunders, Charlotte Saunders and Louisa Saunders have listened and advised most kindly. Felix Wells, as always, has helped simply by being lovely (and putting up with his mother’s unlovely moods).</span></div>
<div class="p-indent"><span>And I know I have been inspired by the lives and deaths of my parents, Basil and Betty Saunders.</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="verse"><span><em class="i">They beckon to me from the other bank.</em><br/> <em class="i">I hear them call, “See where the stream path is!</em><br/> <em class="i">Crossing is not as hard as you might think.”</em></span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="source"><span>—CHARLES CAUSLEY, “EDEN ROCK”</span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781429908573_ack01.vue?31fc2a92